import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BannerOne from '../../components/section-components/BannerOne';
import WelcomeOne from '../../components/section-components/WelcomeOne';
import AwardOne from '../../components/section-components/AwardOne';
import Experiences from '../../components/section-components/Experiences';
import PracticeAreasOne from '../../components/section-components/PracticeAreasOne';
import OurAttorneysOne from '../../components/section-components/OurAttorneysOne';
import Counter from '../../components/section-components/Counter';
import BlogOne from '../../components/section-components/BlogOne';
import TestimonialOne from '../../components/section-components/TestimonialOne';
import FooterOne from '../../common/footer/FooterOne';

const HomeOne = () => {
    return (
        <>
        <HeaderOne />

        <BannerOne />
        
        <WelcomeOne />
        
        <AwardOne /> 
        
        <Experiences />
        
        <PracticeAreasOne />
        
        <OurAttorneysOne />
        
        <Counter />
        
        <BlogOne />
        
        <TestimonialOne />

        <FooterOne />
        </>
    )
}
    
export default HomeOne;